.why {
  color: var(--ink2);
  font-size: 0.875rem;
  line-height: 1.4;
  font-weight: 500;
  font-stretch: 90%;
}

.state {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--s4);
  padding: var(--s6) 0;
  max-width: 68ch;
}

.problem {
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 650;
}

.fix {
  color: var(--ink2);
}

.progress {
  display: flex;
  flex-direction: column;
  gap: var(--s2);
}

.progressRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s3);
  color: var(--ink2);
}

.bar {
  height: 8px;
  border-radius: 4px;
  background: var(--panel2);
  border: 1px solid var(--line);
  overflow: hidden;
}

.barFill {
  display: block;
  height: 100%;
  background: var(--slate);
}

@media (prefers-reduced-motion: no-preference) {
  .barFill {
    transition: width 250ms ease-out;
  }
}
